import { selectIsInspectifyOrder } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { HeaderDesktopSubNavLegacy } from './HeaderDesktopSubNavLegacy.tsx';
import { HeaderDesktopSubNav } from './HeaderDesktopSubNav.tsx';

export const HeaderDesktopSubNavByProductType = () => {
  const isInspectifyOrder = useAppSelector(selectIsInspectifyOrder);
  const shouldUseLegacy = !isInspectifyOrder;
  return shouldUseLegacy ? <HeaderDesktopSubNavLegacy /> : <HeaderDesktopSubNav />;
};
